import React from "react";
import {useTranslation} from "react-i18next";
import {Spinner} from "react-bootstrap";
import GenericTable from "./GenericTable";
import Pagination from "@material-ui/lab/Pagination";
import {scanInOutMetadata} from "./data/scanInOutMetadata";
import {ScanDateFilter} from "./ScanDateFilter";

export const LeftOverTable = React.memo( ({
                                          dateFilters ,
                                          setDateFilters ,
                                          loading,
                                          data,
                                          handleChangePage,
                                          handleChangePage2
}) => {
    const {t} = useTranslation();

    return (
        <>
            {
                loading &&
                (
                    <div className="spinner-global-content">
                        <Spinner variant="success" animation="border" />
                    </div>
                )
            }
            {!loading && (
                <>
                    <div className="w-full d-flex justify-content-center align-items-center">
                        <ScanDateFilter dates={dateFilters} setDates={setDateFilters} />
                    </div>
                    {data && (
                        <div className="row">
                            <div className="col-6">
                                <h6 className="mt-5">{t('hub.leftOver.ScannedOut')}</h6>
                                <hr/>
                                <GenericTable
                                    metadata={scanInOutMetadata(t)}
                                    data={data.scannedOut.result}
                                    keyExtractor={(item) => item.code}
                                />
                                <div style={{width: '100%', display: 'flex',flexDirection:'row',justifyContent:'space-between', marginTop: '5px'}}>
                                    <p>{data.scannedOut.numRowsAll}</p>
                                    <p>{data.scannedOut.pageNo}/{data.scannedOut.maxPage}</p>
                                </div>
                                <div style={{width: '100%', display: 'flex', justifyContent: 'center', marginTop: '5px'}}>
                                    <Pagination
                                        count={data.scannedOut.maxPage}
                                        page={parseInt(data.scannedOut.pageNo)}
                                        onChange={handleChangePage}
                                        color="primary"
                                        size="small"
                                        siblingCount={1}
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <h6 className="mt-5">{t('hub.leftOver.tableLeftOver')}</h6>
                                <hr/>
                                <GenericTable
                                    metadata={scanInOutMetadata(t)}
                                    data={data.result}
                                    keyExtractor={(item) => item.code}
                                />
                                <div style={{width: '100%', display: 'flex',flexDirection:'row',justifyContent:'space-between', marginTop: '5px'}}>
                                    <p>{data.numRowsAll}</p>
                                    <p>{data.pageNo}/{data.maxPage}</p>
                                </div>
                                <div style={{width: '100%', display: 'flex', justifyContent: 'center', marginTop: '5px'}}>
                                    <Pagination
                                        count={data.maxPage}
                                        page={parseInt(data.pageNo)}
                                        onChange={handleChangePage2}
                                        color="primary"
                                        size="small"
                                        siblingCount={1}
                                    />
                                </div>
                            </div>
                        </div>                        
                    )}
                </>
                )
            }
        </>
    )
});